// todo simplify by passing less props that can be derived from the event object

import React from 'react';
import PropTypes from 'prop-types';

import { strings } from '../../../../localization';
import Switch from '../../../../components/common/Switch';
import ProgressOverlay from '../../../../components/common/ProgressOverlay';

import { UPDATE_SETTINGS_TIMEOUT } from '../GlobalSettings';

export default class EventGeneric extends React.PureComponent {
    static propTypes = {
        eventName: PropTypes.string.isRequired,
        eventTitle: PropTypes.string.isRequired,
        eventConfigAvailable: PropTypes.bool,
        eventAvailabilityPending: PropTypes.bool.isRequired,
        eventAvailabilityEnabled: PropTypes.bool,
        eventAvailabilityErrorMessage: PropTypes.string,
        applyEventAvailability: PropTypes.func.isRequired,
        timeoutEventAvailability: PropTypes.func.isRequired,
        expandOrCollapseStateForUIReferences: PropTypes.func.isRequired,
        eventExpandReference: PropTypes.string.isRequired,
        eventExpandReferenceIsExpanded: PropTypes.bool.isRequired,
        showBetaDecoration: PropTypes.bool,
        event: PropTypes.object.isRequired,
    };

    static defaultProps = {
        showBetaDecoration: false,
        eventConfigAvailable: false,
        eventAvailabilityEnabled: false,
        eventAvailabilityErrorMessage: '',
    };

    constructor(props) {
        super(props);
        this.applyEventAvailabilityTimeoutId = undefined;
    }

    componentWillUnmount() {
        clearTimeout(this.applyEventAvailabilityTimeoutId);
    }

    render() {
        if (!this.props.eventConfigAvailable) {
            return null;
        }

        return (
            <div className="setting-group-horiz">
                <div
                    className={
                        this.props.eventExpandReferenceIsExpanded
                            ? 'subgroup'
                            : 'subgroup collapsed'
                    }
                >
                    <h5 className="subgroup-header">
                        <button
                            disabled={true} 
                            className={
                                this.props.eventExpandReferenceIsExpanded
                                    ? 'settings-disclosure-wrapper'
                                    : 'settings-disclosure-wrapper collapsed'
                            }
                            onClick={() => {
                                this.props.expandOrCollapseStateForUIReferences(
                                    !this.props.eventExpandReferenceIsExpanded,
                                    [this.props.eventExpandReference]
                                );
                            }}
                        >
                            {strings['settings_global_events_' + this.props.event.snakeName + '_header']}
                            {this.props.showBetaDecoration && (
                                <span className="beta-decoration">
                                    {strings.settings_global_beta_feature_label}
                                    <span className="tooltiptext">
                                        {strings.settings_global_beta_feature_description}
                                        <a href="mailto:support@ravenconnected.com">
                                            {strings.settings_global_beta_feature_call_to_action}
                                        </a>
                                    </span>
                                </span>
                            )}
                            <i className="material-icons disclosure">
                                keyboard_arrow_up
                            </i>
                        </button>
                    </h5>
                    <h6 className="subgroup-subheader">
                        <div className="setting-group switch-group">
                            <div>
                                <Switch
                                    onChange={() => {
                                        clearTimeout(this.applyEventAvailabilityTimeoutId);
                                        const eventAvailabilityEnabled =
                                            this.props.eventAvailabilityEnabled;
                                        this.applyEventAvailabilityTimeoutId = setTimeout(() => {
                                            this.props.timeoutEventAvailability(
                                                eventAvailabilityEnabled
                                            );
                                        }, UPDATE_SETTINGS_TIMEOUT);

                                        this.props
                                            .applyEventAvailability(
                                                !this.props.eventAvailabilityEnabled
                                            )
                                            .then(
                                                () => {
                                                    clearTimeout(
                                                        this.applyEventAvailabilityTimeoutId
                                                    );
                                                },
                                                () => {
                                                    clearTimeout(
                                                        this.applyEventAvailabilityTimeoutId
                                                    );
                                                }
                                            );
                                    }}
                                    checked={this.props.eventAvailabilityEnabled || false}
                                    disabled={this.props.eventAvailabilityPending}
                                    smallFormat={true}
                                />
                                <label disabled={this.props.eventAvailabilityPending}>
                                    {this.props.eventAvailabilityEnabled
                                        ? strings['settings_global_events_' + this.props.event.snakeName + '_are_enabled']
                                        : strings['settings_global_events_' + this.props.event.snakeName + '_are_disabled']}
                                </label>
                                {this.props.eventAvailabilityPending ? (
                                    <ProgressOverlay />
                                ) : null}
                            </div>
                            <div className="error-message">
                                {this.props.eventAvailabilityErrorMessage}
                            </div>
                        </div>
                    </h6>
                </div>
            </div>
        );
    }
}
